import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SubMenu from './SubMenu';

export default class MainMenuItem extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {SubMenu} parentRef submenu reference
   * @param {Number} parentNum
   * @param {Number} menuNum
   */
  constructor(scene, parentRef, parentNum, menuNum, atlas = ABCyaPhaser.Images.DEFAULT_ATLAS) {
    super(scene);

    this.parentRef = parentRef;
    this.parentNum = parentNum;
    this.menuNum = menuNum;

    this.bg = ABCyaPhaser.Images.addImage(0,0, `Submenu_${this.parentNum + 1}_${this.menuNum + 1}`, this, atlas).setOrigin(0);

    ABCyaPhaser.Container.setContainerInteractive(this, true);
  }

  goAway() {
    ABCyaPhaser.Tweens.addTween(this, 100, { alpha: 0 }, Phaser.Math.Easing.Linear, () => {this.parentRef.destroyMenuItem(this);});
  };
}